import { render, staticRenderFns } from "./appBilibili.vue?vue&type=template&id=3adf4d2a&scoped=true"
import script from "./appBilibili.vue?vue&type=script&lang=js"
export * from "./appBilibili.vue?vue&type=script&lang=js"
import style0 from "./appBilibili.vue?vue&type=style&index=0&id=3adf4d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adf4d2a",
  null
  
)

export default component.exports